// veloure-all-products.js
// All Products data and functionality for Veloure Skin

(function() {
    // Product Data
    const products = [
        // ===== SKIN BOOSTERS =====
        {
            id: "niacinamide",
            title: "Niacinamide Vitamin Boost Serum",
            category: "Skin Boosters",
            price: 25.00,
            comparePrice: 29.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/niacinamide-vitamin-boost-serum",
            variantId: "52357403214137",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/niacinamide_mockup_1e60e465-5494-4b01-8dfa-cd71c6fc3cfc.jpg?v=1776853648"
        },
        {
            id: "hyaluronic",
            title: "Hyaluronic Acid Serum",
            category: "Skin Boosters",
            price: 23.00,
            comparePrice: 27.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/hyaluronic-acid-serum",
            variantId: "52334141473081",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/hyaluronic_acid_mockup.jpg?v=1776701060"
        },
        {
            id: "vitaminc",
            title: "Vitamin C Sensitive Skin Serum",
            category: "Skin Boosters",
            price: 25.00,
            comparePrice: 33.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/vitamin-c-sensitive-skin-serum",
            variantId: "52357791678777",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/alpha_arbutin_mockup_74a6c6ef-39bc-4f56-aba3-e2fa417d798f.jpg?v=1776853648"
        },
        {
            id: "frankincense",
            title: "Frankincense Oil",
            category: "Skin Boosters",
            price: 25.00,
            comparePrice: 29.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/frankincense-oil",
            variantId: "52334143013177",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/facial_oil_mockup.jpg?v=1776701040"
        },

        // ===== TONERS & PEELS =====
        {
            id: "sebuclear",
            title: "SebuClear Solution",
            category: "Toners & Peels",
            price: 20.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/sebuclear-solution",
            variantId: "53293205520697",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/sebuclear1.jpg?v=1778612746"
        },
        {
            id: "lactoglow",
            title: "LactoGlow Solution",
            category: "Toners & Peels",
            price: 21.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/lactoglow-solution",
            variantId: "53293229900089",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/lactoglow1.jpg?v=1778615249"
        },
        {
            id: "tripeel",
            title: "Tri-Acid Peel",
            category: "Toners & Peels",
            price: 28.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/tri-acid-peel",
            variantId: "53293240910137",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/tripeel1.jpg?v=1778616544"
        },

        // ===== EYE CREAMS =====
        {
            id: "avocado",
            title: "Avocado & Caffeine Eye Cream",
            category: "Eye Creams",
            price: 12.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/avocado-caffeine-eye-cream",
            variantId: "53293343932729",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/AVOCADOEYECREAMWITHCAFFEINE.png?v=1778620583"
        },
        {
            id: "antiaging",
            title: "Anti-aging & De-puffing Eye Cream",
            category: "Eye Creams",
            price: 22.00,
            comparePrice: 32.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/anti-aging-de-puffing-eye-cream",
            variantId: "52357968429369",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.16_4.jpg?v=1776939882"
        },

        // ===== MOISTURIZERS & BODY =====
        {
            id: "instaradiance",
            title: "InstaRadiance Moisturizer",
            category: "Moisturizers & Body",
            price: 20.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/instaradiance-moisturizer",
            variantId: "53293394329913",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/Instaradiance.jpg?v=1778617753"
        },
        {
            id: "cellrenew",
            title: "Cell Renew Collagen Ceramide Cream",
            category: "Moisturizers & Body",
            price: 30.00,
            comparePrice: 35.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/cell-renew-collagen-ceramide-cream",
            variantId: "52355630530873",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.15.jpg?v=1776939882"
        },
        {
            id: "deepdrive",
            title: "Deep Drive Moisture Lock",
            category: "Moisturizers & Body",
            price: 22.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/deep-drive-moisture-lock",
            variantId: "52334670512441",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.17.jpg?v=1776939881"
        },
        {
            id: "silkinfusion",
            title: "Silk Infusion Hydrator",
            category: "Moisturizers & Body",
            price: 20.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/silk-infusion-hydrator",
            variantId: "52334430388537",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.16.jpg?v=1776939882"
        },
        {
            id: "bodylotion",
            title: "Body Lotion",
            category: "Moisturizers & Body",
            price: 18.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: true,
            url: "/products/body-lotion",
            variantId: "",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/rn-image_picker_lib_temp_04a3672a-29c3-4aa8-9a78-ccfff372885a.jpg?v=1776549305"
        },

        // ===== CLEANSERS =====
        {
            id: "gentlemilk",
            title: "Gentle Milk Cleanser",
            category: "Cleansers",
            price: 18.00,
            comparePrice: null,
            hasSale: false,
            isSoldOut: false,
            url: "/products/gentle-milk-cleanser",
            variantId: "",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.16_1.jpg?v=1776939882"
        },
        {
            id: "refreshing",
            title: "Refreshing & Hydrating Cleanser",
            category: "Cleansers",
            price: 22.00,
            comparePrice: 30.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/refreshing-hydrating-cleanser",
            variantId: "52359100891449",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/cleanser_mockup_630a5f38-5091-4936-b9f2-d0e464fd8b76.jpg?v=1776853648"
        },

        // ===== BUNDLES & KITS =====
        {
            id: "fullroutine",
            title: "Full Routine",
            category: "Bundles & Kits",
            price: 105.00,
            comparePrice: 115.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/full-routine",
            variantId: "52414483398969",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/full-skincare-routine.png?v=1776534813"
        },
        {
            id: "hydrationkit",
            title: "The Ultimate Hydration Hero Kit",
            category: "Bundles & Kits",
            price: 65.00,
            comparePrice: 85.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/ultimate-hydration-hero-kit",
            variantId: "52347861565753",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.17_1.jpg?v=1776939882"
        },
        {
            id: "pigmentduo",
            title: "Intense Pigment Removal Duo",
            category: "Bundles & Kits",
            price: 50.00,
            comparePrice: 70.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/intense-pigment-removal-duo",
            variantId: "52347860844857",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.16_3.jpg?v=1776939882"
        },
        {
            id: "emberglow",
            title: "EmberGlow Face Scrubber X Frankincense Oil",
            category: "Bundles & Kits",
            price: 57.00,
            comparePrice: 75.00,
            hasSale: true,
            isSoldOut: false,
            url: "/products/emberglow-face-scrubber-frankincense-oil",
            variantId: "52347859861817",
            image: "https://cdn.shopify.com/s/files/1/0908/4230/0729/files/WhatsApp_Image_2026-04-23_at_13.16.16_2.jpg?v=1776939882"
        }
    ];

    // Helper function to get product data from card
    function getProductData(card) {
        const title = card.querySelector('.product-title')?.textContent?.trim() || '';
        const priceText = card.querySelector('.current-price')?.textContent?.replace('$', '').trim() || '0';
        const image = card.querySelector('.product-image')?.getAttribute('src') || '';
        const variantId = card.getAttribute('data-variant-id') || '';

        return {
            title: title,
            variant: null,
            price: parseFloat(priceText),
            variantId: variantId,
            quantity: 1,
            image: image
        };
    }

    // Add to cart function
    function addProductToCart(card) {
        const productData = getProductData(card);
        if (!productData.variantId) {
            console.error('Missing variantId');
            return;
        }

        if (typeof window.addToCart === 'function') {
            window.addToCart(productData);
        } else if (typeof window.addToCartVeloure === 'function') {
            window.addToCartVeloure(productData);
        } else {
            console.error('window.addToCart is not available');
        }
    }

    // Render product card HTML
    function renderProductCard(product) {
        const saleBadge = product.hasSale ? '<span class="sale-badge">SALE</span>' : '';
        const soldOutBadge = product.isSoldOut ? '<span class="sold-out-badge">SOLD OUT</span>' : '';
        const mobileSoldOut = product.isSoldOut ? '<div class="mobile-sold-out">Sold Out</div>' : '';
        
        const comparePriceHtml = product.comparePrice ? 
            `<span class="compare-price">$${product.comparePrice.toFixed(2)}</span>` : '';
        
        const priceHtml = product.hasSale ? 
            `<span class="current-price">$${product.price.toFixed(2)}</span> ${comparePriceHtml}` :
            `<span class="current-price">$${product.price.toFixed(2)}</span>`;
        
        const addToCartDisabled = product.isSoldOut ? 'disabled' : '';
        const addToCartClass = product.isSoldOut ? 'add-to-cart-btn sold-out' : 'add-to-cart-btn';
        const addToCartText = product.isSoldOut ? 'Sold Out' : 'Add to Cart';
        
        const cartIconDisabled = product.isSoldOut ? 'disabled style="opacity:0.5; cursor:not-allowed;"' : '';
        const cartIconClass = product.isSoldOut ? 'image-cart-btn sold-out-mobile' : 'image-cart-btn';
        
        const cardClass = product.isSoldOut ? 'product-card sold-out-card' : 'product-card';
        const cursorStyle = product.isSoldOut ? 'cursor: default;' : '';
        
        return `
            <${product.isSoldOut ? 'div' : 'article'} class="${cardClass}" 
                 data-url="${product.url}" 
                 data-variant-id="${product.variantId}"
                 style="${cursorStyle}">
                <div class="product-image-container">
                    ${saleBadge}
                    ${soldOutBadge}
                    <img src="${product.image}" 
                         alt="${product.title}"
                         class="product-image"
                         loading="lazy">
                    <div class="image-overlay">
                        <a href="${product.url}" class="view-details-btn">
                            <svg viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
                            <span>View Details</span>
                        </a>
                    </div>
                    <button class="${cartIconClass}" type="button" aria-label="Add to cart" ${cartIconDisabled}>
                        <svg viewBox="0 0 24 24"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
                    </button>
                    ${mobileSoldOut}
                </div>
                <div class="product-info">
                    <div class="product-category">${product.category}</div>
                    <h3 class="product-title">${product.title}</h3>
                    <div class="product-price">
                        ${priceHtml}
                    </div>
                    <button class="${addToCartClass}" type="button" ${addToCartDisabled}>
                        <svg viewBox="0 0 24 24"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
                        <span>${addToCartText}</span>
                    </button>
                </div>
            </${product.isSoldOut ? 'div' : 'article'}>
        `;
    }

    // Load all products
    function loadProducts() {
        const grid = document.getElementById('all-products-grid');
        if (!grid) return;
        
        let html = '';
        products.forEach(product => {
            html += renderProductCard(product);
        });
        grid.innerHTML = html;
        
        attachEventListeners();
    }
    
    // Attach click event listeners
    function attachEventListeners() {
        const grid = document.getElementById('all-products-grid');
        if (!grid) return;
        
        grid.addEventListener('click', function(e) {
            const addBtn = e.target.closest('.add-to-cart-btn, .image-cart-btn');
            
            if (addBtn) {
                e.preventDefault();
                e.stopPropagation();
                
                if (addBtn.classList.contains('sold-out') || addBtn.disabled) return;
                
                const card = addBtn.closest('.product-card');
                if (!card) return;
                
                addProductToCart(card);
                return;
            }
            
            if (e.target.closest('button') || e.target.closest('a')) return;
            
            const card = e.target.closest('.product-card');
            if (card && !card.classList.contains('sold-out-card')) {
                const url = card.getAttribute('data-url');
                if (url) window.location.href = url;
            }
        });
    }
    
    // Initialize on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadProducts);
    } else {
        loadProducts();
    }
})();